import { Component, OnInit } from '@angular/core';
import { GruposService } from 'src/app/services/grupos.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-estolas',
  templateUrl: './estolas.component.html',
  styleUrls: ['./estolas.component.scss']
})
export class EstolasComponent implements OnInit {
  enviroment = environment.BASE_URL;
  respuestaEstolas:any;
  estolas;
  respuestaAgregarEstola:any;
  respuestaEditarEstola:any;
  respuestaUpdateEstola:any;

  datosEstola;
  estolaid;

  dtOptions: DataTables.Settings = {
    dom: 'tip',                      // Estructura de la tabla     --> https://datatables.net/reference/option/dom
    lengthMenu: [],                      // Menú de tamaños de página   --> https://datatables.net/reference/option/lengthMenu
    order: [1, 'desc'],
    paging: true,
    pagingType: 'simple_numbers',
    pageLength: 10,
  };
  dtTrigger: Subject<any> = new Subject();
  data;
  formulario;
  formularioEdit;

  constructor( private _getEstolas: GruposService, private modalService: NgbModal, private iziToast: Ng2IzitoastService,
    private _agregarEstola: CatalogosService, private _editarEstola: CatalogosService, private _updateEstola: CatalogosService) { }

  ngOnInit(): void {
    this.getEstolas();
    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }
  }

  getEstolas(){
    this._getEstolas.getEstolas().subscribe(
      data => {
        this.respuestaEstolas = data;
        if(this.respuestaEstolas.success){
          this.estolas = this.respuestaEstolas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }


  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  agregarEstola(){
    this.data = {
      'nombre': this.formulario.nombre,
    }

    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    this._agregarEstola.agregarEstola(formData).subscribe(
      data => {
        this.respuestaAgregarEstola = data;
        if(this.respuestaAgregarEstola.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getEstolas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarEstola(estola){
    this.data = {
      'estola':estola,
    }
    
    this._editarEstola.editarEstola(this.data).subscribe(
      data => {
        this.respuestaEditarEstola= data;
        if(this.respuestaEditarEstola.success){
          this.datosEstola = this.respuestaEditarEstola.content;
          this.formularioEdit.nombre = this.datosEstola.nombre;
          this.estolaid = estola;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateEstola(estola){
    this.data = {
      'estola': estola, 
      'nombre': this.formularioEdit.nombre,
    }

    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('estola', estola);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateEstola.updateEstola(formData).subscribe(
      data => {
        this.respuestaUpdateEstola = data;
        if(this.respuestaUpdateEstola.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getEstolas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
